// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2379d948","732":"ccde79e9","977":"3c3c6d63"}[chunkId] + ".chunk.js";
};